import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Collapse from "@mui/material/Collapse";
import Stack from "@mui/material/Stack";
import React, { useState } from "react";

interface ExpandableDetailsProps {
  children: React.ReactNode;
  isExpanded?: boolean;
  id?: string;
}

export const ExpandableDetails: React.FC<ExpandableDetailsProps> = ({
  children,
  isExpanded = false,
  id = "expandable-details",
}) => {
  const [expanded, setExpanded] = useState(isExpanded);

  return (
    <Stack>
      <Button
        id={`${id}-toggle-button`}
        variant="contained"
        onClick={() => setExpanded((prevValue) => !prevValue)}
        sx={{
          justifyContent: "flex-start",
          backgroundColor: "grey.100",
          color: "text.primary",
          "&:hover": {
            backgroundColor: "grey.200",
          },
          borderRadius: expanded ? "4px 4px 0 0" : "4px",
        }}
        size="small"
        disableRipple
        disableElevation
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={4}
          color="text.secondary"
          gap={0.3}
        >
          {expanded ? (
            <RemoveIcon fontSize="small" />
          ) : (
            <AddIcon fontSize="small" />
          )}
          Details
        </Stack>
      </Button>
      <Collapse in={expanded}>
        <Box
          id={`${id}-content`}
          padding={2}
          bgcolor="grey.100"
          borderRadius="0 0 4px 4px"
        >
          {children}
        </Box>
      </Collapse>
    </Stack>
  );
};
